/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { useTranslation } from '../../../hooks';

type PropsFilterSelectUser = {
  config: {
    component: any;
    name: any;
    status: any;
    bodyRequest: any;
    typeSearch: any;
    roles: any;
  }
}

export function FilterSelectUser({ config }: PropsFilterSelectUser) {
  const { t } = useTranslation();
  if (!config || !config.component) return <>No configurado</>;
  return React.createElement(config.component, {
    name: 'user',
    label: `${t(config.name)}`,
    placeholder: `${t('Enter a')} ${t(config.name)}`,
    isModal: true,
    roles: config.roles
  });
}

export default FilterSelectUser;
